'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

/**
 * Clears any stale inline `pointer-events` style left on <body> by Radix
 * primitives (Dialog, DropdownMenu, Sheet, Popover, Select, ...) whose
 * close cleanup effect was skipped because a Next.js route transition
 * unmounted the subtree before Radix could restore the body style.
 *
 * See: https://github.com/radix-ui/primitives/issues/2122
 */
export function BodyPointerEventsGuard() {
  const pathname = usePathname();

  useEffect(() => {
    if (document.body.style.pointerEvents === 'none') {
      document.body.style.pointerEvents = '';
    }
  }, [pathname]);

  return null;
}
